type Props = { onRetry: () => void; message?: string };

export function ModalErrorPanel({ onRetry, message }: Props) {
  return (
    <div style={{ padding: 32, textAlign: "center" }}>
      <div style={{ color: "var(--ink-2)", marginBottom: 12 }}>
        {message ?? "Couldn't load data for this substance."}
      </div>
      <button type="button" className="btn xs" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
